import { render, staticRenderFns } from "./Button1.vue?vue&type=template&id=005ef796&scoped=true&"
import script from "./Button1.vue?vue&type=script&lang=js&"
export * from "./Button1.vue?vue&type=script&lang=js&"
import style0 from "./Button1.vue?vue&type=style&index=0&id=005ef796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ef796",
  null
  
)

export default component.exports